import { AutoCompleteDictionary } from "components/AutoCompleteDictionary/AutoCompleteDictionary";
import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { CheckableButtonList } from "components/CheckableButtonList/CheckableButtonList";
import { CustomerPositionWithInfo } from "components/CustomerPositionWithInfo/CustomerPositionWithInfo";
import Datepicker from "components/DatePicker/DatePicker";
import { DictionarySelectBox } from "components/DictionaryTypeSelect/DictionaryTypeSelect";
import { EnumerationTypeSelect } from "components/EnumerationTypeSelect/EnumerationTypeSelect";
import { Message } from "components/Message/Message";
import { MultiSelectBox } from "components/MultiSelectBox/MultiSelectBox";
import { Person } from "components/Person/Person";
import { Price } from "components/Price/Price";
import { RangeSlider } from "components/RangeSlider/RangeSlider";
import { SelectBox } from "components/Select/Select";
import { Textbox } from "components/Textbox/Textbox";
import { Time } from "components/Time/Time";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import React, { useContext, useState } from "react";
import {
  InputTextType,
  InputTextTypePlaceholder,
  InputTypes,
  OrganizationType,
} from "types/enum";
import { ENDPOINTS } from "utils/endpoints";
import { trans } from "utils/helpers";
import { DynamicDataGrid } from "./DynamicDataGrid";
import { DynamicDictionary } from "./DynamicDictionary";
import { StepInForms } from "./DynamicFormsPage/StepInForms";
import { SimpleGrid } from "./SimpleGrid/SimpleGrid";
import { PriceInput } from "components/PriceInput/PriceInput";
import Items from "./Items/Items";
import ApiRequestConfigurator from "./ApiRequestConfigurator/ApiRequestConfigurator";

interface InputDetectorPropes {
  typeName: string;
  property: any;
  handleTime?: (e: string) => void;
  handleRowsData?: (e: any) => void;
  CalculateCallBack?: any;
  mode?: "create" | "view" | "edit";
  EnableDisplacement?: boolean;
  formBuilderMode?: boolean;
  firstAutoValue?: boolean;
  stepperIndex?: any;
  hidden?: boolean;
  handleStepper?: () => void;
  handleOpenStep?: (e) => void;
  changeProperty: (e) => void;
  dataEntry?: boolean;
  useOnInput?: any;
  onClick?: any;
  disable?: any;
  CalculateRoundingPlace?:any
  setCodeCallback?:any
}
export const InputDetector = React.memo(
  ({
    CalculateCallBack,
    disable,
    onClick,
    useOnInput = false,
    changeProperty,
    dataEntry = false,
    handleStepper,
    handleOpenStep,
    hidden,
    EnableDisplacement = false,
    firstAutoValue,
    formBuilderMode = false,
    typeName,
    property,
    mode = "edit",
    stepperIndex,
    handleRowsData,
    handleTime,
    CalculateRoundingPlace,
    setCodeCallback
  }: InputDetectorPropes) => {
    const [todayDate, settodayDate] = useState<string | null>(
      new Date().toISOString()
    );

    
    const layoutContext = useContext(LayoutContext);

    let content = {
      PositionDictionary: {
        type: "PositionDictionary",
        body: (
          <div
            className={`w-100 mb-1 position-relative p-1 ${
              property?.OrganizationType == OrganizationType.Customers
                ? ""
                : "widthControl"
            } formBuilder__formBx__PositionDictionary`}
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__PositionDictionary"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            {property?.OrganizationType == OrganizationType.Customers ? (
              <CustomerPositionWithInfo
                name={property?.SystemKey}
                label={property?.label}
                DescriptionKey={"PositionDictionaryDescription"}
                required={property?.required}
                mode={
                  (mode && !property?.disable) ||
                  (!window.location.href.includes("builder") &&
                    layoutContext.currentUserPosition.OrganizationType !=
                      OrganizationType.Customers)
                    ? mode
                    : "view"
                }
                value={
                  (firstAutoValue || firstAutoValue == undefined) &&
                  (property?.defaultValue
                    ? property?.defaultValue
                    : layoutContext.currentUserPosition.OrganizationType ==
                        OrganizationType.Customers || property?.fillWithCurrent
                    ? layoutContext.currentUserPosition.PositionId
                    : null)
                }
              />
            ) : (
              <AutoCompleteDictionary
              autoFocus={false}
                required={property?.required}
                className={"text-box"}
                DescriptionKey={"PositionDictionaryDescription"}
                name={property?.SystemKey}
                label={property?.label}
                fixedparams={true}
                baseUrl={undefined}
                url={
                  ENDPOINTS.BaseInformation.position.dictionaryOrganizationType
                }
                value={
                  (firstAutoValue || firstAutoValue == undefined) &&
                  (property?.defaultValue
                    ? property?.defaultValue
                    : layoutContext.currentUserPosition.OrganizationType ==
                        OrganizationType.Customers || property?.fillWithCurrent
                    ? layoutContext.currentUserPosition.PositionId
                    : null)
                }
                mode={
                  (mode && !property?.disable) ||
                  (!window.location.href.includes("builder") &&
                    layoutContext.currentUserPosition.OrganizationType !=
                      OrganizationType.Customers)
                    ? mode
                    : "view"
                }
                params={{
                  OrganizationType: property?.OrganizationType
                    ? property?.OrganizationType
                    : OrganizationType.Employees,
                }}
              />
            )}
            {/*  <Position
               label={property?.label} 
               DescriptionKey={"PositionDictionaryDescription"}
               name={property?.SystemKey} 
               mode={((mode && !property?.disable)||(!window.location.href.includes("builder")&& layoutContext.currentUserPosition.OrganizationType != OrganizationType.Customers))?  mode: 'view'} 
               resetForm={false} 
               required={property?.required}
               value={(firstAutoValue||firstAutoValue==undefined )&&(property?.defaultValue? property?.defaultValue: (layoutContext.currentUserPosition.OrganizationType == OrganizationType.Customers ?layoutContext.currentUserPosition.PositionId:null))}
             
            /> */}
          </div>
        ),
      },
      Sex: {
        type: "Sex",
        body: (
          <div
            className={`w-100 position-relative p-1 widthControl formBuilder__formBx__PositionDictionary`}
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__PositionDictionary"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <EnumerationTypeSelect
              required={property?.required}
              mode={mode && !property?.disable ? mode : "view"}
              label={property?.label}
              name={property?.SystemKey}
              value={
                (firstAutoValue || firstAutoValue == undefined) &&
                (property?.defaultValue ? property?.defaultValue : null)
              }
              enumTypeSelect="Sex"
            />
          </div>
        ),
      },
      Position: {
        type: "Position",
        body: (
          <div
            className={`w-100 position-relative p-1 ${
              property?.OrganizationType == OrganizationType.Customers
                ? ""
                : "widthControl"
            } formBuilder__formBx__PositionDictionary`}
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__PositionDictionary"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            {property?.OrganizationType == OrganizationType.Customers ? (
              <CustomerPositionWithInfo
                name={property?.SystemKey}
                DescriptionKey={property?.SystemKey + "Description"}
                label={property?.label}
                required={property?.required}
                mode={mode && !property?.disable ? mode : "view"}
                value={
                  (firstAutoValue || firstAutoValue == undefined) &&
                  (property?.defaultValue
                    ? property?.defaultValue
                    : layoutContext.currentUserPosition.OrganizationType ==
                        OrganizationType.Customers || property?.fillWithCurrent
                    ? layoutContext.currentUserPosition.PositionId
                    : null)
                }
              />
            ) : (
              <AutoCompleteDictionary
              autoFocus={false}

                required={property?.required}
                className={"text-box"}
                onChange={(e) => {
                  CalculateCallBack &&
                    CalculateCallBack(e, property?.SystemKey);
                }}
                name={property?.SystemKey}
                DescriptionKey={property?.SystemKey + "Description"}
                label={property?.label}
                baseUrl={undefined}
                url={
                  ENDPOINTS.BaseInformation.position.dictionaryOrganizationType
                }
                value={
                  (firstAutoValue || firstAutoValue == undefined) &&
                  (property?.defaultValue
                    ? property?.defaultValue
                    : layoutContext.currentUserPosition.OrganizationType ==
                        OrganizationType.Customers || property?.fillWithCurrent
                    ? layoutContext.currentUserPosition.PositionId
                    : null)
                }
                mode={mode && !property?.disable ? mode : "view"}
                params={{
                  OrganizationType: property?.OrganizationType
                    ? property?.OrganizationType
                    : OrganizationType.Employees,
                }}
              />
            )}
          </div>
        ),
      },
      Person: {
        type: "Person",
        body: (
          <div
            className={`w-100 position-relative p-1 widthControl formBuilder__formBx__PositionDictionary`}
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__PositionDictionary"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <Person
              label={property?.label}
              name={property?.SystemKey}
              DescriptionKey={property?.SystemKey + "Description"}
              mode={mode && !property?.disable ? mode : "view"}
              resetForm={false}
              required={property?.required}
              value={
                (firstAutoValue || firstAutoValue == undefined) &&
                (property?.defaultValue
                  ? property?.defaultValue
                  : layoutContext.currentUserPosition.OrganizationType ==
                      OrganizationType.Customers || property?.fillWithCurrent
                  ? layoutContext.currentUserPosition.PersonId
                  : null)
              }
            />
          </div>
        ),
      },
      ProgressBar: {
        type: "ProgressBar",
        body: (
          <div
            className={`w-100 px-1 d-flex ${
              formBuilderMode ? "" : "m-2 px-0 pt-2 pb-5"
            } position-relative formBuilder__formBx__ProgressBar`}
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100  formBuilder__formBx__ProgressBar "
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <RangeSlider
              label={property?.label}
              name={property?.SystemKey}
              mode={mode && !property?.disable ? mode : "view"}
              defaultValue={property?.defaultValue}
              resetForm={false}
              required={property?.required}
              useTrans={false}
            />
          </div>
        ),
      },

      // fileUpload: {type: 'fileUpload',body:(
      // <div className="widthControl w-100 position-relative formBuilder__formBx__fileUpload">
      //     <div className="position-absolute w-100 h-100 formBuilder__formBx__fileUpload" style={{zIndex:maker ? '1' : 'none'}}></div>
      //     <FileInput useTrans={false} mode={mode && !property?.disable ?  mode: 'view'} name={property?.SystemKey} lable={property.label} maxSize={25600000} hideSrc={true}/>
      // </div>
      // )},

      RadioButton: {
        type: "RadioButton",
        body: (
          <div
            className={`widthControl p-1   w-100 position-relative formBuilder__formBx__RadioButton`}
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__RadioButton"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <CheckableButtonList
              mode={mode && !property?.disable ? mode : "view"}
              checkableListLabel={property?.label}
              verticalDirection={
                property.direction == "true" || property.direction == true
                  ? true
                  : false
              }
              checkableButtonName={property?.SystemKey}
              checkableBtnLabelList={property?.Keywords}
              onchange={(e) => {
                CalculateCallBack &&
                  CalculateCallBack(e + "", property?.SystemKey);
              }}
              disable={property?.disable}
              value={property?.defaultValue}
              required={property?.required}
              checkbaleType="radio"
              useTrans={false}
            />
          </div>
        ),
      },

      checkBox: {
        type: "checkBox",
        body: (
          <div
            className={`widthControl p-1 mt-1} w-100 d-flex align-items-center position-relative formBuilder__formBx__checkBox`}
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__checkBox"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <CheckableButton
              customeStyle={{
                display:
                  !formBuilderMode && property?.hidden ? "none" : "block",
                filter: property?.hidden ? "blur(2px)" : "",
              }}
              required={property?.label}
              readOnly={property?.disable}
              labelText={property?.label}
              inputName={property?.SystemKey}
              onchange={(e) => {
                CalculateCallBack &&
                  CalculateCallBack(e + "", property?.SystemKey);
              }}
              mode={mode && !property?.disable ? mode : "view"}
              defaultChecked={
                property?.defaultValue === true ||
                property?.defaultValue === "true"
              }
              type="checkbox"
              useTrans={false}
              value={
                property?.defaultValue === true ||
                property?.defaultValue === "true"
              }
            />
          </div>
        ),
      },

      selectBox: {
        type: "selectBox",
        body: (
          <div
            className="widthControl mb-1 p-1 w-100 position-relative formBuilder__formBx__selectBox"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__selectBox"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <SelectBox
              lable={property.label}
              name={property?.SystemKey}
              setWithFristORvalue={true}
              onChange={(e) => {
                CalculateCallBack &&
                  CalculateCallBack(e.target.value, property?.SystemKey);
              }}
              mode={mode && !property?.disable ? mode : "view"}
              value={property.defaultValue}
              val={property?.Keywords?.map((item) => item.SystemKey)}
              required={property?.required}
              options={property?.Keywords?.map((item) => item.name)}
              selectType="select"
              useTrans={false}
            />
          </div>
        ),
      },

      timeLength: {
        type: "timeLength",
        body: (
          <div
            className="widthControl p-1 w-100 position-relative formBuilder__formBx__timeLength"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__timeLength"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <Time
              label={property.label}
              name={property?.SystemKey}
              IdString={property?.SystemKey}
              defaultValue={property?.defaultValue}
              mode={mode && !property?.disable ? mode : "view"}
              required={property.required}
              type="Time"
              useTrans={false}
            />
          </div>
        ),
      },

      time: {
        type: "time",
        body: (
          <div
            className="widthControl p-1 w-100 position-relative formBuilder__formBx__time"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__time"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <Datepicker
              lable={property.label}
              name={property?.SystemKey}
              mode={mode && !property?.disable ? mode : "view"}
              val={property?.defaultValue ? property.defaultValue : null}
              withTime={true}
              disableDayPicker={true}
              setIsoTime={(e) => {
                handleTime && handleTime(e);
              }}
              required={property.required}
              useTrans={false}
              format={"HH:mm"}
              placeholder={formBuilderMode ? "۱۳:۲۶" : null}
              onOpenPickNewDate={true}
            />
          </div>
        ),
      },

      date: {
        type: "date",
        body: (
          <div
            className="widthControl p-1 w-100 position-relative formBuilder__formBx__date"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__date"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <Datepicker
              lable={property.label}
              name={property?.SystemKey}
              mode={
                property?.disable
                  ? "view"
                  : mode && !property?.disable
                  ? mode
                  : "view"
              }
              val={
                property?.defaultValueDateTimeNow
                  ? todayDate
                  : property?.defaultValue
                  ? property.defaultValue
                  : null
              }
              setIsoTime={(e) => {
                handleTime && handleTime(e);
              }}
              withTime={property?.DatePickerState != "normal" ? true : false}
              disableDayPicker={
                property?.DatePickerState == "disableDayPicker" ? true : false
              }
              required={property.required}
              onOpenPickNewDate={true}
              useTrans={false}
              placeholder={
                formBuilderMode
                  ? property?.DatePickerState != "normal"
                    ? "۱۴۰۳/۰۴/۰۴ ۱۳:۲۶"
                    : "۱۴۰۳/۰۴/۰۴"
                  : ""
              }
            />
          </div>
        ),
      },

      button: {
        type: "button",
        body: (
          <div
            className="position-relative p-1 widthControl w-100 formBuilder__formBx__text"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            {/* <div className="position-absolute w-100 h-100 formBuilder__formBx__text" style={{pointerEvents:'auto',cursor:"auto",zIndex:EnableDisplacement ? '1' : 'none'}}></div> */}
            <Button
              onClick={onClick && !disable ? onClick : () => {}}
              btnType={
                property?.buttonType ? property?.buttonType : "primaryFill"
              }
              value={property?.label}
              disabled={
                mode && !property?.disable && !disable ? false : (true as any)
              }
            />
          </div>
        ),
      },

      text: {
        type: "text",
        body: (
          <div
            className="position-relative p-1 widthControl w-100 formBuilder__formBx__text"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__text"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <Textbox
              labelText={property?.label}
              textboxName={property?.SystemKey}
              textboxType={InputTextType[property?.InputType] ?? "text"}
              defaultValue={property?.defaultValue}
              mode={mode && !property?.disable ? mode : "view"}
              //onChange={(e)=>{  CalculateCallBack&&CalculateCallBack(e.target.value ,property?.SystemKey )}}
              maxLength={property?.maxLength}
              minLength={+property?.minLength}
              min={property?.min == null ? undefined : +property?.min}
              max={property?.max == null ? undefined : +property?.max}
              minHeight={property?.minHeight ? property?.minHeight : 2}
              required={property?.required}
              useTrans={false}
              useOnInput={true}
              placeholder={
                !formBuilderMode || property?.placeholder
                  ? property?.placeholder
                  : InputTextTypePlaceholder[InputTextType[property?.InputType]]
              }
            />
          </div>
        ),
      },
      number: {
        type: "number",
        body: (
          <div
            className="position-relative p-1 widthControl w-100 formBuilder__formBx__text"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__text"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            <Textbox
              labelText={property?.label}
              textboxName={property?.SystemKey}
              textboxType={"number"}
              useOnInput={useOnInput}
              //onChange={(e)=>{  CalculateCallBack&&CalculateCallBack(e.target.value ,property?.SystemKey )}}
              defaultValue={property?.defaultValue}
              mode={mode && !property?.disable ? mode : "view"}
              maxLength={property?.maxLength}
              minLength={+property?.minLength}
              min={property?.min == null ? undefined : +property?.min}
              max={property?.max == null ? undefined : +property?.max}
              minHeight={property?.minHeight ? property?.minHeight : 2}
              required={property?.required}
              useTrans={false}
              placeholder={
                !formBuilderMode || property?.placeholder
                  ? property?.placeholder
                  : InputTextTypePlaceholder.number
              }
            />
          </div>
        ),
      },

      price: {
        type: "price",
        body: (
          <div
            className="widthControl p-1 w-100 position-relative formBuilder__formBx__price"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              className="position-absolute w-100 h-100  formBuilder__formBx__price"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>

            <PriceInput
              label={property?.label}
              useOnInput={useOnInput}
          
              onBlurHandler={(e)=>{

                
              ; CalculateRoundingPlace&&CalculateRoundingPlace(e?.replaceAll(',','') ,property?.SystemKey )}}
              name={property?.SystemKey}
              mode={mode && !property?.disable ? mode : "view"}
              useTrans={false}
              defaultValue={property?.defaultValue}
              placeholder={formBuilderMode ? "100.00$" : null}
              required={property?.required}
            />
          </div>
        ),
      },

      emptySpace: {
        type: "emptySpace",
        body: (
          <div
            className={`widthControl p-1 w-100 d-flex align-items-end formBuilder__formBx__emptySpace ${
              !formBuilderMode ? "" : ""
            }`}
            style={{
              height: "50px",
              marginTop: "22px",
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <div
              style={{
                background:
                  "repeating-linear-gradient(45deg,rgb(255, 255, 255),rgb(235, 235, 235) 2%,rgb(255, 255, 255) 1%)",
              }}
              className={!formBuilderMode ? "" : "text-box__box form-control"}
            >
              <div className="invisible"></div>
            </div>
          </div>
        ),
      },

      // label:{type: 'label',body:(
      //     <div className="widthControl p-1 w-100 position-relative" style={{zIndex:maker ? '1' : 'none'}}>
      //         <div style={{fontSize:property?.labelSize +'px',fontStyle:property?.labelStyle,fontWeight:property?.labelWeight,color:property?.color}}>{property?.labelText ? property?.labelText : 'label'}</div>
      //     </div>
      //     )},
      Message: {
        type: "Message",
        body: (
          <div
            className="widthControl p-1 w-100 position-relative formBuilder__formBx__Message "
            style={{
              zIndex: EnableDisplacement ? "1" : "none",
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <Message
              title={property?.messageTitle}
              type={property?.messageType}
              message={property?.message}
            />
          </div>
        ),
      },
      Step: {
        type: "Step",
        body: (
          <div
            className="widthControl w-100 position-relative formBuilder__formBx__Step"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <StepInForms property={property} handleOpenStep={handleOpenStep} />
          </div>
        ),
      },
      Card: {
        type: "Card",
        body: (
          <div
            className="widthControl w-100 position-relative formBuilder__formBx__Step"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <StepInForms
              isCard={true}
              property={property}
              handleOpenStep={handleOpenStep}
            />
          </div>
        ),
      },
      simpleGrid: {
        type: "simpleGrid",
        body: (
          <div
            className="widthControl w-100 position-relative formBuilder__formBx__simpleGrid"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <SimpleGrid
              theadLength={property?.theadLength ?? 2}
              tbodyLength={property?.tbodyLength ?? 2}
              theadData={property?.theadData || []}
              tbodyData={property?.tbodyData || []}
            />
          </div>
        ),
      },
      attachment: {
        type: "attachment",
        body: (
          <div
            className=" d-flex row  w-100 position-relative formBuilder__formBx__simpleGrid"
            style={{
              display: !formBuilderMode && property?.hidden ? "none" : "block",
              filter: property?.hidden ? "blur(2px)" : "",
            }}
          >
            <CheckableButton
              required={property?.label}
              readOnly={property?.disable}
              labelText={trans("msg_showintab")}
              inputName={property?.SystemKey}
              onchange={(e) => {
                CalculateCallBack &&
                  CalculateCallBack(e + "", property?.SystemKey);
              }}
              mode={"view"}
              type="radio"
              useTrans={false}
              value={true}
              defaultChecked={
                property?.attachmentType === "tab" || !property?.attachmentType
              }
            />
            {/* <CheckableButton
             required={property?.label}
             readOnly={property?.disable}
             labelText={'نمایش در گالری'} 
             inputName={property?.SystemKey} 
            //  onchange={(e)=>{CalculateCallBack&&CalculateCallBack(e+"" ,property?.SystemKey )}}
             mode={ 'view'} 
           
             type="radio"
             useTrans={false}
                          defaultChecked={property?.attachmentType==='gallery'}

          //   value={property?.defaultValue===true ||property?.defaultValue==="true" }              
             /> */}
          </div>
        ),
      },
      activityStatus: {
        type: "activityStatus",
        body: (
          <div className="position-relative p-1 widthControl w-100 formBuilder__formBx__text">
            <div
              className="position-absolute w-100 h-100 formBuilder__formBx__text"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            {dataEntry ? (
              <EnumerationTypeSelect
                value={property?.defaultValue}
                name={property?.SystemKey}
                enumTypeSelect="ActivityStatus"
                mode={mode}
                label={property?.label ? property?.label : "state"}
              />
            ) : (
              <Textbox
                labelText={trans(property?.label)}
                textboxName={property?.SystemKey}
                textboxType={"text"}
                defaultValue={
                  property?.defaultValue == 2
                    ? trans("inactive")
                    : trans("active")
                }
                mode={"view"}
                //onChange={(e)=>{  CalculateCallBack&&CalculateCallBack(e.target.value ,property?.SystemKey )}}
                required={property?.required}
                placeholder={
                  !formBuilderMode || property?.placeholder
                    ? property?.placeholder
                    : InputTextTypePlaceholder[
                        InputTextType[property?.InputType]
                      ]
                }
              />
            )}
          </div>
        ),
      },




  items: {
        type: "activityStatus",
        body: (
          <div className="position-relative p-1 widthControl w-100 formBuilder__formBx__text">
            <div
              className=""
              //style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            {dataEntry ? (
          


<Items mode={mode} property={property} setCodeCallback={setCodeCallback}/>

            ) : (
              <Textbox
                labelText={trans(property?.label)}
                textboxName={property?.SystemKey}
                textboxType={"text"}

                mode={"view"}
                //onChange={(e)=>{  CalculateCallBack&&CalculateCallBack(e.target.value ,property?.SystemKey )}}
                required={property?.required}
              defaultValue={property?.defaultValue}
     value={property?.defaultValue}
     placeholder={property?.placeholder}
              />
            )
            }
          </div>
        ),
      },





      url: {
        type: "url",
        body: (
          <div className="position-relative p-1 widthControl w-100 formBuilder__formBx__text">
            <div
              className=" w-100 h-100 formBuilder__formBx__text"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            {dataEntry ? (
              property?.inputType == "SelectBox" ? (
                <DictionarySelectBox
                  label={trans(property?.label)}
                  name={property?.SystemKey}
                  params={
                    property?.Keywords &&
                    !!property?.Keywords?.length &&
                    Object.assign(
                      {},
                      ...property?.Keywords.map((item) => ({
                        [item?.name]: item?.SystemKey,
                      }))
                    )
                  }
                  baseUrl={property?.baseUrl}
                  endPoint={property?.endpoint}
                  required={property?.required}
                  value={property?.defaultValue ? property?.defaultValue : null}
                  mode={mode}
                />
              ) : property?.inputType == "AutoCompleteDictionary"?(
                <AutoCompleteDictionary
              autoFocus={false}

                  required={property?.required}
                  label={trans(property?.label)}
                  name={property?.SystemKey}
                  params={
                    property?.Keywords &&
                    !!property?.Keywords?.length &&
                    Object.assign(
                      {},
                      ...property?.Keywords.map((item) => ({
                        [item?.name]: item?.SystemKey,
                      }))
                    )
                  }
                  baseUrl={property?.baseUrl}
                  url={property?.endpoint}
                  value={property?.defaultValue ? property?.defaultValue : null}
                  mode={mode}
                />
              ):<MultiSelectBox    
                 keys={property?.Keys}
                  label={trans(property?.label)}
                  name={property?.SystemKey}
                  required={property?.required}

                        mode={mode}
                  value={property?.defaultValue ? property?.defaultValue : null}

                               params={
                    property?.Keywords &&
                    !!property?.Keywords?.length &&
                    Object.assign(
                      {},
                      ...property?.Keywords.map((item) => ({
                        [item?.name]: item?.SystemKey,
                      }))
                    )
                  }          
                  baseUrl={property?.baseUrl}
                  url={property?.endpoint}
                  returnObj={true}
                  />
                  
            ) : (
              <Textbox
                labelText={trans(property?.label)}
                textboxName={property?.SystemKey}
                textboxType={"text"}
                defaultValue={""}
                mode={"view"}
                //onChange={(e)=>{  CalculateCallBack&&CalculateCallBack(e.target.value ,property?.SystemKey )}}
                required={property?.required}
                placeholder={
                  !formBuilderMode || property?.placeholder
                    ? property?.placeholder
                    : InputTextTypePlaceholder[
                        InputTextType[property?.InputType]
                      ]
                }
              />
            )}
          </div>
        ),
      },

      apiRequestConfigurator: {
        type: "apiRequestConfigurator",
        body: (
          <div className="position-relative p-1 widthControl w-100 formBuilder__formBx__text">
            <div
              className=" w-100 h-100 formBuilder__formBx__text"
              style={{ zIndex: EnableDisplacement ? "1" : "none" }}
            ></div>
            {dataEntry ? 


<ApiRequestConfigurator name={property?.SystemKey}
label={trans(property?.label)}
required={property?.required}
mode={mode}
defaultValue={property?.defaultValue}
endpoint={property?.endpoint}
baseUrl={property?.baseUrl}
onChange={(value,obj)=>CalculateCallBack(value,property?.SystemKey,false,obj)}
/>


          : (
              <Textbox
                labelText={trans(property?.label)}
                textboxName={property?.SystemKey}
                textboxType={"text"}
                defaultValue={""}
                mode={"view"}
                //onChange={(e)=>{  CalculateCallBack&&CalculateCallBack(e.target.value ,property?.SystemKey )}}
                required={property?.required}
                placeholder={
                  !formBuilderMode || property?.placeholder
                    ? property?.placeholder
                    : InputTextTypePlaceholder[
                        InputTextType[property?.InputType]
                      ]
                }
              />
            )}
          </div>
        ),
      },





      
    };

    return (
      <>
        {content[
          typeName == "number" || typeName == "decimalNumber"
            ? "number"
            : typeName == "textArea" || typeName == "SystemNumber"
            ? "text"
            : typeName
        ] != undefined ? (
          content[
            typeName == "number" || typeName == "decimalNumber"
              ? "number"
              : typeName == "textArea" ||
                typeName == "number" ||
                typeName == "decimalNumber" ||
                typeName == "SystemNumber"
              ? "text"
              : typeName
          ]?.body
        ) : (
          <>
            <div
              className={`w-100 position-relative p-1 widthControl formBuilder__formBx__PositionDictionary`}
              style={{
                display:
                  !formBuilderMode && property?.hidden ? "none" : "block",
                filter: property?.hidden ? "blur(2px)" : "",
              }}
            >
              {property?.type != InputTypes.dataGrid ? (
                <>
                  <div
                    className="position-absolute w-100 h-100 formBuilder__formBx__PositionDictionary"
                    style={{ zIndex: EnableDisplacement ? "1" : "none" }}
                  ></div>
                  <DynamicDictionary
                    label={property?.label}
                    name={property?.SystemKey}
                    DescriptionKey={property?.SystemKey + "Description"}
                    mode={mode && !property?.disable ? mode : "view"}
                    onChange={(e) => {
                      CalculateCallBack &&
                        CalculateCallBack(e.Id, property?.SystemKey,true);
                    }}
                    resetForm={false}
                    returnObj={true}
                    DynamicObj={property}
                    required={property?.required}
                    value={
                      (firstAutoValue || firstAutoValue == undefined) &&
                      (property?.defaultValue ? property?.defaultValue : null)
                    }
                  />
                </>
              ) : (
                <>
                  <DynamicDataGrid
                    dataEntry={dataEntry}
                    dataGridDataCallBack={changeProperty}
                    handleRowsData={handleRowsData}
                    name={property?.SystemKey}
                    mode={mode && !property?.disable ? mode : "view"}
                    resetForm={false}
                    DynamicObj={{ ...property }}
                    required={property?.required}
                    tbodyLength={property?.tbodyLength}
                    resizeOption={false}
                  />
                </>
              )}
            </div>
          </>
        )}
      </>
    );
  }
);
